<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import PrimaryLayout from '@/layouts/PrimaryLayout'
import BlankLayout from '@/layouts/BlankLayout'
import HomeLayout from '@/layouts/HomeLayout'

export default {
  components: {
    PrimaryLayout,
    BlankLayout,
    HomeLayout
  },
  computed: {
    layout() {
      return this.$store.getters.layout
    }
  }
}
</script>

<style lang="scss">
#app {
  height: 100vh;
}
</style>
